import React from 'react';

function PublishIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        d="M6.59,2.831 L7.483,1.821 L7.483,7.5 C7.483,7.776 7.707,8 7.983,8 C8.259,8 8.483,7.776 8.483,7.5 L8.483,1.821 L9.376,2.831 C9.475,2.943 9.612,3 9.75,3 C9.868,3 9.986,2.959 10.081,2.875 C10.288,2.691 10.308,2.376 10.125,2.169 L8.357,0.169 C8.166,-0.046 7.798,-0.046 7.607,0.169 L5.839,2.169 C5.657,2.376 5.677,2.691 5.884,2.875 C6.089,3.057 6.404,3.039 6.59,2.831 Z"
      />
      <path
        d="M13.964,2.667 C13.777,2.459 13.46,2.444 13.258,2.627 C13.052,2.812 13.034,3.128 13.218,3.333 C14.367,4.617 15,6.274 15,8 C15,11.859 11.859,15 8,15 C4.141,15 1,11.859 1,8 C1,6.274 1.633,4.617 2.782,3.334 C2.928,3.171 3.081,3.016 3.241,2.867 C3.443,2.68 3.456,2.363 3.269,2.16 C3.082,1.957 2.765,1.946 2.562,2.133 C2.378,2.303 2.204,2.482 2.038,2.667 C0.724,4.134 0,6.028 0,8 C0,12.411 3.589,16 8,16 C12.411,16 16,12.411 16,8 C16,6.028 15.276,4.135 13.964,2.667 Z"
      />
    </svg>
  );
}

export default PublishIcon;
